import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';

import { snProductMappingListQueryToApiParams } from './listQueryToApiParams';

/**
 * SN 產品名稱對照列表。
 * GET `/aftersales/sn-product-mapping`
 *
 * @param {object} listQuery
 */
export async function fetchSnProductMappingList(listQuery) {
  const { data: raw } = await request.get('/aftersales/sn-product-mapping', {
    params: snProductMappingListQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
